import React from "react";
import { Modal } from "react-bootstrap";
import checkOutlineLarge from "../../assets/images/check_outline_large.svg";
import "./FeeScheduleInvalidated.scss";

export interface FeeScheduleInvalidatedProps {
    close: () => void,
    confirm: () => void,
    feeScheduleNames: string[],
    invalidatingProperty: string,
    invalidatingValue: string,
}

export default function FeeScheduleInvalidated(props: FeeScheduleInvalidatedProps) {
    return <Modal id="fee-schedule-invalid" show={true}>
        <Modal.Title>
            Fee Schedule Invalid
        </Modal.Title>
        <Modal.Body>
            {props.feeScheduleNames.length == 1 ? <>
                <p>
                    The selected {props.invalidatingProperty}, {props.invalidatingValue},
                    is not compatible with the fee schedule {props.feeScheduleNames[0]}.
                </p>
                <p>
                    Continue with changing the {props.invalidatingProperty}? The
                    fee schedule that was selected will be cleared, and you will
                    need to select a new one.
                </p>
            </> : <>
                <p>
                    The following fee schedules are not compatible with the
                    {props.invalidatingProperty} {props.invalidatingValue}:
                    <ul>
                        {props.feeScheduleNames.map(fee => <li>{fee}</li>)}
                    </ul>
                </p>
                <p>
                    Continue with changing the {props.invalidatingProperty}? The
                    fee schedules listed will be cleared, and you will need to
                    select new ones.
                </p>
            </>}
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                className="btn"
                onClick={_event => props.confirm()}
            >
                <img src={checkOutlineLarge}/>
                Confirm
            </button>
            <button
                type="button"
                className="cancel-button"
                onClick={_event => props.close()}
            >
                Cancel
            </button>
        </Modal.Footer>
    </Modal>
}
